import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { PayoutMethod } from '@app/modules/direct/services/payout-methods.service';
import { ButtonComponent, LoadingSpinnerComponent } from '@ui';

@Component({
  selector: 'sbnb-add-task-rule-flow-cost-and-payments',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, ButtonComponent],
  templateUrl: './add-task-rule-flow-cost-and-payments.component.html',
})
export class AddTaskRuleFlowCostAndPaymentsComponent {
  readonly #router = inject(Router);

  estimatedCostPerClean = input<string | null>();
  paymentMethodDetails = input<PayoutMethod | null>();
  paymentMethodDetailsLoading = input<boolean>();

  totalToPrepay = computed(() => {
    const cost = this.estimatedCostPerClean();
    if (!cost) return '$0.00';

    // Extract numeric value from currency string (e.g. "$93.00" -> 93)
    const numericValue = parseFloat(cost.replace(/[^0-9.-]+/g, ''));
    const doubled = numericValue * 2;

    // Format back to currency string
    return `$${doubled.toFixed(2)}`;
  });

  navigateToPayouts() {
    this.#router.navigate(['/settings/payouts']);
  }
}
